import * as React from 'react';
import { DateTime } from 'ui';
import { parseAsDateUTC, createUTCDate, dateToUTC, createFormatters } from 'app/infrastructure/data/date';
import { FilterCommonProps, OptionType, SubOptionType } from './types';
import { MeatballPanel } from 'app/area/search-filters/filters/meatball-panel';

export class FilterDate extends React.PureComponent<FilterCommonProps<Date>> {

  private onChange = (value: Date) => {
    this.props.onChange(this.props.id, [{
      optionType: OptionType.specified,
      subOptionType: SubOptionType.dateFrom,
      value
    }]);
  };

  private currentValue = () => {
    const { values } = this.props;
    return values && values.length > 0 ? values[0].value : undefined;
  };

  public render() {
    const { id, locale, meatballPanelConfiguration } = this.props;
    const currentValue = this.currentValue();

    return <>
      <MeatballPanel configuration={meatballPanelConfiguration} />
      <DateTime
        useTime={false}
        value={currentValue}
        componentId={`${id}_picker`}
        className="dateTime"
        parseDate={parseAsDateUTC}
        createDate={createUTCDate}
        cloneDate={dateToUTC}
        locale={locale}
        onChange={this.onChange}
        captionWrapper={'form'}
        {...createFormatters(locale)}
      />
    </>;
  }
}
